import cloudModule from './cloud.module';
import template from './cloud.component.html';
import style from './cloud.component.scss';

export default cloudModule.component('cloud', {
    template: template,
    style: style
});



// WEBPACK FOOTER //
// ./modules/cloud/cloud.component.js